// Typed easing tokens for Framer Motion and GSAP.
// Mirrors the --ease-* CSS variables defined in src/app/globals.css §@theme.

export const ease = {
  smooth: [0.25, 0.1, 0.25, 1.0] as const,
  power: [0.65, 0, 0.35, 1.0] as const,
  bounce: [0.68, -0.55, 0.265, 1.55] as const,
  cinematic: [0.16, 1, 0.3, 1] as const,
} as const;

export const duration = {
  fast: 0.2,
  base: 0.4,
  slow: 0.8,
  cinematic: 1.6,
} as const;
